export default "__VITE_ASSET__DxB2Wt7T__"